import {
  defaultRules,
  inlineRegex,
  unescapeUrl,
  reactElement,
  sanitizeUrl,
  htmlTag,
  parserFor,
  outputFor,
} from "simple-markdown";

// This plugin overrides the default link parser and adds the ability to add the target attribute to
// anchor tags. Almost all of the code below is a copy-paste from the internals of simple markdown
// which the regex piece on line 22 being updated to include the target functionality.

// Usage: [text](url){target=_blank} or _self or any other acceptable target value
// All external link default to target _blank. Disable this manually by:
// [text](url){!target}
// -----------------------------------------------------------------------------

// An "external" link is any full link:
// https://google.com/blah/blah
// Even https://app.threatkey.com/blah/blah
const ExternalLink: RegExp = /^https?:\/\//i;
const LinkInside = "(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*";
const LinkHrefAndTitle =
  "\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*";

const TargetBlankLink = {
  order: defaultRules.em.order - 0.5,

  match: inlineRegex(
    new RegExp(
      `^\\[(${LinkInside})\\]\\(${LinkHrefAndTitle}\\)(\\{(!)?target(="?([^"}]+)"?)?\\})?`
    )
  ),

  parse: function (capture: any, parse: Function, state: any) {
    const target = unescapeUrl(capture[2]); // plugin-speak for URL
    const linkTargetIsDisabled = capture[5] !== undefined;
    const linkIsExternal = ExternalLink.test(target.trim());
    const linkTarget = linkTargetIsDisabled
      ? undefined
      : linkIsExternal
      ? "_blank"
      : capture[7];

    //
    return {
      target,
      content: parse(capture[1], state),
      title: capture[3],
      link_target: linkTarget,
    };
  },

  react: function (node: any, output: Function, state: any) {
    return reactElement("a", state.key, {
      href: sanitizeUrl(node.target),
      title: node.title,
      target: node.link_target,
      children: output(node.content, state),
    });
  },

  html: function (node: any, output: Function, state: any) {
    return htmlTag("a", output(node.content, state), {
      href: sanitizeUrl(node.target),
      title: node.title,
      target: node.link_target,
    });
  },
};

const rules = {
  ...defaultRules,
  link: TargetBlankLink,
};

const markdownParser = parserFor(rules);
const parseMarkdown = function (source: string) {
  return markdownParser(source, { inline: false });
};
const reactOutput = outputFor(rules, "react");

// -----------------------------------------------------------------------------

export function getMarkdownAsReact(markdown: string): React.ReactNode {
  return reactOutput(parseMarkdown(markdown || ""));
}
